import { DirectiveOptions } from "vue";

const isAlphanumericKey = (event: KeyboardEvent): void => {
  if (!/^[A-Za-z0-9]+$/.test(event.key) && event.key != "Backspace" && event.key != "Delete" && event.key != "ArrowLeft" && event.key != "ArrowRight") {
    event.preventDefault();
  }
};

const directive: DirectiveOptions = {
  bind(el) {
    el.addEventListener("keydown", isAlphanumericKey);
  },
  unbind(el) {
    el.removeEventListener("keydown", isAlphanumericKey);
  }
};

export default directive;
